// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpensePage_wrapper__CVLuc"};